export const defaultsQuery = `
  Defaults {
    thumbnail {
      id
      sizes {
        thumbnail {
          url
        }
      }
    }
  }
`
